export const POPULAR_POST_IMG_FALLBACK =
  "https://static.share.market/images/blog/992/704/fallback_most_popular_articles.png";
export const POPULAR_POST_IMG_FALLBACK_ALT =
  "Buzz Popular Post";
